import utils from "../utils/utils";
import {fancybox} from "../components/fancybox";

const key = {
    localStorage: 'fancybox-message',
}

export function appendNonceToData(data, action) {
    const payload = Array.isArray(data)
        ? data.filter((field) => field.name !== "_wpnonce" && field.name !== "action")
        : [];

    payload.push({name: "_wpnonce", value: utils.get_nonce()}, {name: "action", value: action});
    return payload;
}

export function setDefaultSingleParameter(name, value) {
    let url = new URL(window.location.href);
    if (!url.searchParams.has(name)) {
        url.searchParams.set(name, value);
        window.history.pushState({}, '', url);
    }
}

export function setSingleParameter(name, value) {
    if (typeof value !== 'undefined' && value !== null) {
        let url = new URL(window.location.href);
        url.searchParams.set(name, value);
        window.history.pushState({}, '', url);
    }
}

export function getSingleParameter(name) {
    let url = new URL(window.location.href);
    return url.searchParams.get(name);
}

export function onLoadCheckFancyboxMessage() {
    const message = localStorage.getItem(key.localStorage);
    if (message) {
        fancybox.openFancybox(message);
        localStorage.removeItem(key.localStorage);
    }
}

export function setFancyboxMessage(message) {
    if (message) {
        localStorage.setItem(key.localStorage, message);
        location.reload();
    }
}

export {getTranslation, formatTranslation} from "../services/translations";

export function buildPeriodValue(startDate, endDate = null) {
    const start = (startDate || '').toString().trim();
    const end = (endDate || startDate || '').toString().trim();
    if (!start || !end) return '';
    return start === end ? start : `${start}...${end}`;
}

export function lowerCaseEmail() {
    $(document).on('keyup', 'input[name="email"]', function () {
        let _this = $(this);
        let val = _this.val().toLowerCase().replace(/[^a-z0-9@._-]/g, '');
        _this.val(val);
    });
}
